// extracted by mini-css-extract-plugin
var _1 = "pfx-ModalOrBottomSheet-module__hide-share-modal-header--phRpY";
export { _1 as "hideShareModalHeader" }
